<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevicemodel.list.filters.model') }}:</label>
            <input v-model.lazy="filters.model" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevicemodel.list.filters.idDeviceBrand') }}:</label>
            <el-select
                    v-model="filters.idDeviceBrand"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder=""
                    :remote-method="remoteMethod"
                    :loading="loading">
              <el-option
                      v-for="item in deviceBrands"
                      :key="item['@id']"
                      :label="item.brandTitle"
                      :value="item['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevicemodel.list.filters.idDeviceType') }}:</label>
            <el-select
                    v-model="filters.idDeviceType"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder=""
                    :remote-method="remoteMethod"
                    :loading="loading">
              <el-option
                      v-for="item in deviceTypes"
                      :key="item['@id']"
                      :label="item.title"
                      :value="item['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'DeviceModelsFiltering',

  props: {
    getPage: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      delay: 500,
      filters: {
        model: '',
        idDeviceBrand: [],
        idDeviceType: []
      },
      deviceBrands: [],
      deviceTypes: [],
      loading: false
    }
  },

  directives: {
    debounce
  },

  watch: {
    'filters.model': function () {
      this.filter()
    },
    'filters.idDeviceBrand': function () {
      this.filter()
    },
    'filters.idDeviceType': function () {
      this.filter()
    }
  },

  created () {
    this.getDeviceBrands()
    this.getDeviceTypes()
  },

  methods: {
    filter () {
      let url = 'e_x_c_m_device_models?_page=1'
      if (this.filters.model) {
        url += '&model=' + this.filters.model
      }
      if (this.filters.idDeviceBrand.length > 0) {
        for (let i in this.filters.idDeviceBrand) {
          url += '&idDeviceBrand[]=' + this.getIdLink(this.filters.idDeviceBrand[i])
        }
      }
      if (this.filters.idDeviceType.length > 0) {
        for (let i in this.filters.idDeviceType) {
          url += '&idDeviceType[]=' + this.getIdLink(this.filters.idDeviceType[i])
        }
      }
      this.getPage(url)
    },
    getDeviceTypes () {
      let params = {
        'pagination': false,
        'state': 1
      }
      this.deviceTypes = []
      this.$http.get('api/e_x_c_m_device_types', {
        params
      })
        .then(response => {
          this.deviceTypes = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getDeviceBrands () {
      let params = {
        'pagination': false,
        'state': 1
      }
      this.deviceBrands = []
      this.$http.get('api/e_x_c_m_device_brands', {
        params
      })
        .then(response => {
          this.deviceBrands = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    remoteMethod () {
      // console.log()
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
